import { MapPin, CalendarFold, Users, Search } from 'lucide-react';

export default function Type5TopBanner(props) {

    const {
        flights,
        bookingEngine,
        filteredFlights,
        showSearchPageForm,
        setShowSearchPageForm,
    } = props;

    const formatDate = (isoDate) => {
        const date = new Date(isoDate);
        return date.toLocaleDateString('en-US', {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
        });
    };

    let CABIN_CLASS="";
    let ORIGIN_CITY="";
    let ORIGIN_CITY_CODE="";
    let ORIGIN_IATA="";
    let DESTINATION_CITY="";
    let DESTINATION_IATA="";
    let DESTINATION_CITY_CODE="";
    let TRAVEL_DATES="";
    let PASSENGERS=[];
    let is_one_way=true;

    if(Array.isArray(flights) && flights.length > 1){
        const flight = flights?.[0];
        const {
            total_amount, 
            total_currency, 
            slices, 
            owner, 
            conditions, 
            available_services, 
            passengers 
        } = flight;

        PASSENGERS=passengers;

        CABIN_CLASS = slices[0]?.segments[0]?.passengers[0]?.cabin?.marketing_name;
        const SEGMENT_LENGTH = slices[0]?.segments?.length;
        ORIGIN_CITY = slices[0].segments[0]?.origin?.city_name;
        DESTINATION_CITY = slices[0]?.segments[(SEGMENT_LENGTH - 1)]?.destination?.city_name;
        ORIGIN_IATA = slices[0]?.segments[0]?.origin?.iata_code;
        ORIGIN_CITY_CODE = slices[0]?.segments[0]?.origin.iata_city_code
        DESTINATION_IATA = slices[0]?.segments[(SEGMENT_LENGTH - 1)]?.destination?.iata_code;
        DESTINATION_CITY_CODE = slices[0]?.segments[(SEGMENT_LENGTH - 1)]?.destination.iata_city_code;
        TRAVEL_DATES=formatDate(slices?.[0]?.segments?.[0]?.departing_at);

        if(slices.length>1){
            const LAST_SLICE_SEG_LENGTH=slices[(slices.length-1)]?.segments?.length;
            if(ORIGIN_CITY===slices[(slices.length-1)]?.segments[LAST_SLICE_SEG_LENGTH-1]?.destination?.city_name){
                is_one_way=false;
                TRAVEL_DATES=(formatDate(slices?.[0]?.segments?.[0]?.departing_at)+" • "+formatDate(slices[(slices.length-1)]?.segments[LAST_SLICE_SEG_LENGTH-1]?.departing_at));
            }
        }
    }

  return (
    <div className="bg-blue-600 text-white" style={{marginBottom: 10, display: showSearchPageForm && "none", marginTop: -30, background: bookingEngine?.actionButtonsBg}}>
      <div className="max-w-7xl mx-auto px-4 py-6 grid grid-cols-1 md:grid-cols-3 gap-8">
        {/*<div className="flex items-center gap-8" style={{flexWrap: "wrap"}}>*/}
            <div className="flex items-center gap-8">
                <div className="flex items-center gap-2" style={{marginRight: 40}}>
                    <MapPin style={{ width: "19px", height: "19px", marginRight: 10 }} />
                    <div>
                    <div style={{color: `color-mix(in srgb, ${bookingEngine?.actionButtonsBg} 20%, white)`}} className="text-blue-100 text-sm">
                        From</div>
                    <div style={{color: bookingEngine?.actionButtonsTxtColor}}>
                        {ORIGIN_CITY} ({ORIGIN_IATA})</div>
                    </div>
                </div>
                
                {/*<div style={{color: bookingEngine?.actionButtonsTxtColor}} className="text-2xl">
                    →</div>*/}
                
                <div className="flex items-center gap-2">
                    <MapPin style={{ width: "19px", height: "19px", marginRight: 10 }} />
                    <div>
                    <div style={{color: `color-mix(in srgb, ${bookingEngine?.actionButtonsBg} 20%, white)`}} className="text-blue-100 text-sm">
                        To</div>
                    <div style={{color: bookingEngine?.actionButtonsTxtColor}}>
                        {DESTINATION_CITY} ({DESTINATION_IATA})</div>
                    </div>
                </div>
            </div>
            
            <div className="flex items-center gap-8">
                <div className="flex items-center gap-2" style={{marginRight: 40}}>
                    <CalendarFold style={{ width: "19px", height: "19px", marginRight: 10 }} />
                    <div>
                    <div style={{color: `color-mix(in srgb, ${bookingEngine?.actionButtonsBg} 20%, white)`}} className="text-blue-100 text-sm">
                        Departure</div>
                    <div style={{color: bookingEngine?.actionButtonsTxtColor}}>
                        {TRAVEL_DATES}</div>
                    </div>
                </div>
                
                <div className="flex items-center gap-2">
                    <Users style={{ width: "19px", height: "19px", marginRight: 10 }} />
                    <div>
                    <div style={{color: `color-mix(in srgb, ${bookingEngine?.actionButtonsBg} 20%, white)`}} className="text-blue-100 text-sm">
                        Passengers</div>
                    <div style={{color: bookingEngine?.actionButtonsTxtColor}}>
                        {PASSENGERS.length>1?(`${PASSENGERS.length} People`):"1 Person"}</div>
                    </div>
                </div>
            </div>
          <button  style={{border: "none", background: `color-mix(in srgb, ${bookingEngine?.actionButtonsBg} 20%, white)`, color: bookingEngine?.actionButtonsBg, borderRadius: bookingEngine?.actionButtonBorderRadius, minWidth: "fit-content", padding: 15, fontSize: 13 }}
            onClick={()=>setShowSearchPageForm(!showSearchPageForm)}
            className="flex items-center gap-2 justify-center bg-white text-blue-600 px-6 py-2 rounded-lg hover:bg-blue-50 transition-colors">
            <i className='fa-solid fa-search' style={{ fontSize: 14, marginRight: 10, color: "black" }} />
            Search New
          </button>
        </div>
      {/*</div>*/}
    </div>
  );
}